import type MagicString from '~/lib/static-analysis/magic';

const markdownRegex = /\.(txt|md|mdx|markdown|mkd|astro)$/;

export async function transformTSWrap(code: MagicString, path: string) {
  if (!markdownRegex.test(path) && code.str.startsWith('typescript```') && code.str.endsWith('```')) {
    code.replace(0, 13, '');
    code.replace(code.str.length - 3, code.str.length, '');
  }
}
